import { HStack, IconButton, Td, Tr, useToast } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';
import { MenuLocationsContext } from '../../../../hooks/useMenuItemsLocation';

interface Props {
  location: any;
  onDelete?: (locationId: any) => void;
  onEditClick?: (location: any) => void;
}

const Item: React.FC<Props> = ({ location, onDelete, onEditClick }) => {
  const toast = useToast();

  const { deleteLocation, loading } = useContext(MenuLocationsContext);

  const handleDelete = async (locationId: string) => {
    try {
      if (window.confirm('Deseja realmente excluir esse item?')) {
        deleteLocation(locationId);
        toast({
          title: 'Sucesso!',
          description: 'Item excluído com sucesso',
          status: 'success',
          position: 'top-right',
        });
        if (onDelete) {
          onDelete(locationId);
        }
      }
    } catch (err: any) {
      toast({
        title: 'Opss!!',
        description:
          err?.response?.data?.message ||
          err?.message ||
          'Tivemos um erro, tente novamente mais tarde',
        status: 'error',
        position: 'top-right',
      });
    }
  };

  return (
    <>
      <Tr bg="#fff">
        <Td>{location?.name}</Td>
        <Td>{location?.slug}</Td>
        <Td>
          <HStack spacing={3}>
            <IconButton
              color="#CECECE"
              aria-label="edit-page"
              rounded="md"
              icon={<FaPen size={17} />}
              size="xs"
              colorScheme="#FFFFFF"
              isLoading={loading}
              onClick={() => {
                if (onEditClick) {
                  onEditClick(loading);
                }
              }}
            />
            <IconButton
              aria-label="delete-page"
              rounded="md"
              color="#FF6565"
              icon={<FaTrash size={17} />}
              size="xs"
              colorScheme="#FFFFFF"
              isLoading={loading}
              onClick={() => {
                handleDelete(location?.id);
              }}
            />
          </HStack>
        </Td>
      </Tr>
    </>
  );
};

export default Item;
